import { render, staticRenderFns } from "./SliceVimeoYoutubePlayer.vue?vue&type=template&id=0e5bfca1&lang=pug&"
import script from "./SliceVimeoYoutubePlayer.vue?vue&type=script&lang=js&"
export * from "./SliceVimeoYoutubePlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports